import React, { useEffect, useState } from "react";
import "../css/ThailandStat.css";
import InfoBox from "./InfoBox";
import numeral from "numeral";
import { Line } from "react-chartjs-2";
import { FormControl, MenuItem, Select } from "@material-ui/core";

function ThailandStat() {
  const [info, setInfo] = useState({});
  //   const [infoHistory, setInfoHistory] = useState({});

  const [duration, setDuration] = useState("30");
  const [dataY, setDataY] = useState([]);
  const [dataCases, setDataCases] = useState([]);
  const [dataRecovered, setDataRecovered] = useState([]);
  const [dataDeaths, setDataDeaths] = useState([]);

  const onDurationChange = (e) => {
    console.log(e.target.value);
    setDuration(e.target.value);
  };

  useEffect(() => {
    const getInfo = async () => {
      await fetch(
        "https://disease.sh/v3/covid-19/countries/Thailand?strict=true"
      )
        .then((response) => response.json())
        .then((data) => {
          //   console.log(data);
          setInfo(data);
        });
    };
    getInfo();
  }, []);

  useEffect(() => {
    const getInfoHistory = async () => {
      await fetch(
        `https://disease.sh/v3/covid-19/historical/thailand?lastdays=${duration}`
      )
        .then((response) => response.json())
        .then((data) => {
          //   console.log(data.timeline.cases);

          const yData = [];
          const tempCases = [];
          const tempRecovered = [];
          const tempDeaths = [];

          for (let a in data.timeline.cases) {
            tempCases.push(a);
            yData.push(data.timeline.cases[a]);
          }

          for (let a in data.timeline.recovered) {
            tempRecovered.push(data.timeline.recovered[a]);
          }

          for (let a in data.timeline.deaths) {
            tempDeaths.push(data.timeline.deaths[a]);
          }

          setDataY(yData);
          setDataCases(tempCases);
          setDataRecovered(tempRecovered);
          setDataDeaths(tempDeaths);
        });
    };
    getInfoHistory();
  }, [duration]);

  const data = {
    labels: dataCases,
    datasets: [
      {
        label: "# Cases in Thailand",
        data: dataY,
        fill: false,
        backgroundColor: "rgb(255,34,80)",
        borderColor: "rgba(255,34,80, 0.2)",
      },
      {
        label: "# Recovered in Thailand",
        data: dataRecovered,
        fill: false,
        backgroundColor: "RGB(80,255,23)",
        borderColor: "rgba(80,255,23, 0.2)",
      },
      {
        label: "# Deaths in Thailand",
        data: dataDeaths,
        fill: false,
        backgroundColor: "RGB(178,127,255)",
        borderColor: "rgba(178,127,255, 0.2)",
      },
    ],
  };

  const options = {
    maintainAspectRatio: false,
    scales: {
      yAxes: [
        {
          type: "linear",
          display: true,
          position: "left",
          id: "y-axis-1",
        },
      ],
    },
  };

  return (
    <div className="thailandStat">
      <h2>COVID-19 OUTBREAK</h2>
      <p>Data: https://disease.sh/</p>
      <h3>Thailand</h3>

      <div className="thailandStat__body">
        <div className="thailandStat__bodyLeft">
          <InfoBox
            topic="New Cases"
            value={numeral(info.todayCases).format("0,0")}
            color="red"
          />
          <InfoBox
            topic="Total Cases"
            value={numeral(info.cases).format("0,0")}
            color="red"
          />
          <InfoBox
            topic="Recovered"
            value={numeral(info.recovered).format("0,0")}
            color="green"
          />
          <InfoBox
            topic="Deaths"
            value={numeral(info.deaths).format("0,0")}
            color="purple"
          />
        </div>

        <div className="thailandStat__bodyRight">
          <div className="lineChart">
            <div className="lineChart__header">
              Last
              <FormControl className="lineChart__form">
                <Select value={duration} onChange={onDurationChange}>
                  <MenuItem value="30">30</MenuItem>
                  <MenuItem value="60">60</MenuItem>
                  <MenuItem value="90">90</MenuItem>
                  <MenuItem value="120">120</MenuItem>
                </Select>
              </FormControl>
              days
            </div>

            {dataCases && dataY && <Line data={data} options={options} />}
          </div>
        </div>
      </div>
    </div>
  );
}

export default ThailandStat;
